import React, { useState, useCallback } from 'react';
import axios from 'axios';
import ChartComponent from './ChartComponent';

function App() {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [chartData, setChartData] = useState(null);

    const sendMessage = useCallback(async () => {
        if (!input.trim()) return;

        const userMsg = { sender: 'user', text: input };
        setMessages((prev) => [...prev, userMsg]);

        try {
            let res;
            if (input.trim().toLowerCase().startsWith('show')) {
                // Call /chart API
                res = await axios.post('https://docker.thewebtual.com/chart', { question: input });
            } else {
                // Call /ask API
                res = await axios.post('https://docker.thewebtual.com/ask', { question: input });
            }

            const isChart = res.data.type === 'chart';
            const botMsg = {
                sender: 'bot',
                text: isChart ? "Here's your chart." : res.data.answer,
            };

            setChartData(isChart ? res.data.chart : null);
            setMessages((prev) => [...prev, botMsg]);
        } catch (error) {
            console.error(error);
            setMessages((prev) => [
                ...prev,
                { sender: 'bot', text: 'Sorry, something went wrong.' },
            ]);
        }

        setInput('');
    }, [input]);


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') sendMessage();
    };

    return (
        <div className="min-h-screen bg-gray-100 p-6 flex flex-col items-center">
            <div className="w-full max-w-2xl bg-white rounded-xl shadow-md p-6">
                <h2 className="text-2xl font-bold mb-4 text-gray-800">AI Chart Chatbot</h2>

                <div className="h-72 overflow-y-auto border border-gray-300 rounded-md p-4 mb-4 space-y-2 bg-gray-50">
                    {messages.map((msg, i) => (
                        <div
                            key={i}
                            className={`text-sm ${
                                msg.sender === 'user' ? 'text-right text-blue-600' : 'text-left text-gray-700'
                            }`}
                        >
                            <span className="font-semibold">{msg.sender}:</span> {msg.text}
                        </div>
                    ))}
                </div>

                <div className="flex items-center space-x-2">
                    <input
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={handleKeyPress}
                        placeholder="Ask something..."
                        className="flex-1 px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                        onClick={sendMessage}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                    >
                        Send
                    </button>
                </div>

                {chartData && (
                    <div className="mt-6">
                        <ChartComponent chart={chartData} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default App;
